var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.isFormValid,
                    callback: function($$v) {
                      _vm.isFormValid = $$v
                    },
                    expression: "isFormValid"
                  }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Crear Mensaje" } },
                        [
                          _vm._t("prependInformacionGeneral"),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md12: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  label: _vm.formFields.estado.label,
                                  id: _vm.formFields.estado.id,
                                  color: "yellow",
                                  readonly: _vm.isVerDetalle,
                                  hint: _vm.hint,
                                  "persistent-hint": true
                                },
                                on: { change: _vm.cambio },
                                model: {
                                  value: _vm.estado,
                                  callback: function($$v) {
                                    _vm.estado = $$v
                                  },
                                  expression: "estado"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md12: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|max:50",
                                    expression: "`required|max:50`"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.nombre.label,
                                  "data-vv-name": _vm.formFields.nombre.id,
                                  id: _vm.formFields.nombre.id,
                                  counter: "50",
                                  disabled: _vm.isVerDetalle,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.nombre.id
                                  )
                                },
                                model: {
                                  value: _vm.formFields.nombre.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.nombre,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.nombre.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm9: "", md9: "" } },
                            [
                              _c(
                                "v-card",
                                [
                                  _c(
                                    "v-toolbar",
                                    { attrs: { color: "primary", dark: "" } },
                                    [
                                      _c(
                                        "v-toolbar-title",
                                        { staticClass: "subheading" },
                                        [_vm._v("Redactar el mensaje")]
                                      )
                                    ],
                                    1
                                  ),
                                  _c("v-textarea", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "max:200",
                                        expression: "'max:200'"
                                      }
                                    ],
                                    staticClass: "mx-2 white",
                                    attrs: {
                                      "data-vv-name": _vm.formFields.mensaje.id,
                                      "error-messages": _vm.errors.collect(
                                        _vm.formFields.mensaje.id
                                      ),
                                      counter: 200,
                                      disabled: _vm.isVerDetalle,
                                      rows: "10",
                                      "prepend-icon": "mdi-comment"
                                    },
                                    model: {
                                      value: _vm.formFields.mensaje.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.mensaje,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.mensaje.value"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm3: "", md3: "" } },
                            [
                              _c(
                                "v-card",
                                [
                                  _c(
                                    "v-toolbar",
                                    { attrs: { color: "primary", dark: "" } },
                                    [
                                      _c(
                                        "v-toolbar-title",
                                        { staticClass: "subheading" },
                                        [_vm._v("Variables")]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-list",
                                    _vm._l(this.vVariables, function(item) {
                                      return _c(
                                        "v-list-tile",
                                        {
                                          key: item.Id,
                                          attrs: {
                                            disabled: _vm.isVerDetalle,
                                            icon: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.concatenateString(item)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-list-tile-content",
                                            [
                                              _c("v-list-tile-title", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    item.nombreMostrar
                                                  )
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-list-tile-action",
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    color: "primary",
                                                    fab: "",
                                                    small: "",
                                                    dark: ""
                                                  }
                                                },
                                                [_c("v-icon", [_vm._v("add")])],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _c("br")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }